<template>
  <ul class="footbar">
    <li class="frist" @click="gethome">
      <i class="active footerIcon"></i>
      <span class="spanClass active">首页</span>
    </li>
    <!-- <li @click="getService">
      <i class="a footerIcon"></i>
      <span class="spanClass">客服</span>
    </li> -->
    <li @click="getgoods">
      <i class="a footerIcon"></i>
      <span class="spanClass">商品</span>
    </li>
    <li @click="getcar" class="carIndex">
      <i class="car footerIcon"></i>
      <span class="car spanClass">购物车</span>
      <a v-if="count && count>0" style=" width: 17px;height: 17px;line-height: 17px;" class="icon">{{count}}</a>
    </li>
    <li class="last" @click="getmyself">
      <i class="footerIcon"></i>
      <span class="spanClass">我的</span>
    </li>
  </ul>
</template>

<script>
export default {
    name: "foot",
    data() {
        return {
            msg: "",
            active: 0,
            activeFont: 0
        };
    },
    props: {
        footerIcon: {
            type: Number
            // required:true
        }
    },
    watch: {
        // 监听icon高亮
        active: function(val, oldVal) {
            var iList = document.getElementsByClassName("footerIcon");
            for (let i = 0; i < iList.length; i++) {
                iList[i].classList.remove("active");
            }
            iList[val].classList.add("active");
            var iList1 = document.getElementsByClassName("spanClass");
            for (let i = 0; i < iList1.length; i++) {
                iList1[i].classList.remove("active");
            }
            iList1[val].classList.add("active");
        },
        footerIcon: function(val, oldVal) {
            var iList = document.getElementsByClassName("footerIcon");
            for (let i = 0; i < iList.length; i++) {
                iList[i].classList.remove("active");
            }
            iList[val].classList.add("active");
            var iList1 = document.getElementsByClassName("spanClass");
            for (let i = 0; i < iList1.length; i++) {
                iList1[i].classList.remove("active");
            }
            iList1[val].classList.add("active");
        }
    },
    computed: {
        count: function() {
            if (this.$store.state.count) {
                return this.$store.state.count;
            } else {
                return localStorage.getItem("goodsNo");
            }
        }
    },
    methods: {
        gethome() {
            this.active = 0;
            this.$router.push({ path: "/home" });
        },
        // getService () {
        //     this.active = 1
        //     this.$router.push({ path: "/helpService" });
        //     // window.location.replace("https://media.shinho.net.cn/ChatClient/IndexNew?com=Sys_Company62c735e5c96149088c4b202649119161&id=01")
        // },
        getgoods() {
            this.active = 1;
            this.$router.push({ path: "/goods" });
        },
        getcar() {
            this.active = 2;
            console.log(this.active)
            this.$router.push({ path: "/car" });
        },
        getmyself() {
            this.active = 3;
            this.$router.push({ path: "/myself" });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footbar {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 14px 0 10px 0;
    display: flex;
    justify-content: space-around;
    background: #fff;
    box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.03);
    z-index: 3;
}
.footbar li {
    font-size: 22px;
    color: #a9a8a8;
    list-style-type: none;
}
.footbar .carIndex {
    position: relative;
}
.footbar .carIndex .icon {
    display: block;   
    background-image: url("../assets/images/footerImages/circle.png");
    background-size: 100% 100%;
    position: absolute;
    left: 34px;
    top: -10px;
    color: #fff;
    font-size: 20px;
    text-align: center;
}
.footbar .carIndex img {
    width: 30px;
    height: 30px;
}
.footbar li i {
    width: 44px;
    height: 44px;
    display: block;
}
.footbar li i.car {
    margin-left: 4px;
}
.footbar li span {
    line-height: 32px;
}
.footbar li span.active {
    color: #8cc747;
}
/* spanActive */
.footbar li:nth-child(1) i {
    background: url("../assets/images/footerImages/home.png") no-repeat;
    background-size: 44px 42px;
}
.footbar li:nth-child(1) i.active {
    background: url("../assets/images/footerImages/activehome.png") no-repeat;
    background-size: 44px 42px;
}
/* .footbar li:nth-child(2) i {
    background: url("../assets/images/footerImages/service.png") no-repeat;
    background-size: 44px 42px;
}
.footbar li:nth-child(2) i.active {
    background: url("../assets/images/footerImages/serviceActive.png") no-repeat;
    background-size: 44px 42px;
} */
.footbar li:nth-child(2) i {
    background: url("../assets/images/footerImages/goods.png") no-repeat;
    background-size: 44px 42px;
}
.footbar li:nth-child(2) i.active {
    background: url("../assets/images/footerImages/activegoods.png") no-repeat;
    background-size: 44px 42px;
}
.footbar li:nth-child(3) i.active {
    background: url("../assets/images/footerImages/activecar.png") no-repeat;
    background-size: 44px 42px;
}
.footbar li:nth-child(3) i {
    background: url("../assets/images/footerImages/car.png") no-repeat;
    background-size: 44px 42px;
}
.footbar li:nth-child(4) i {
    background: url("../assets/images/footerImages/myself.png") no-repeat;
    background-size: 44px 42px;
}
.footbar li:nth-child(4) i.active {
    background: url("../assets/images/footerImages/activemyself.png") no-repeat;
    background-size: 44px 42px;
}
.activeFont {
    color: #8dc748;
}
</style>



// WEBPACK FOOTER //
// src/components/footnav.vue